module.exports = __webpack_public_path__ + "img/tacna-logo.b49ad0d9.svg";